import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import IntimatePiercingImage from '../../Assets/Piercing Services/nape piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function IntimatePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Intimate Piercing UAE | 500 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Intimate Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Intimate Piercing 500 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={IntimatePiercingImage} alt="Intimate Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Intimate Piercing</h3>

          <p>
            Enhance your confidence and personal expression with our professional intimate piercing services in the UAE, available at a premium price of 500 AED. Intimate piercing is a highly specialized body piercing that focuses on discreet and sensitive areas, offering a unique way to express individuality while maintaining privacy and elegance. This type of piercing is chosen by individuals who value both aesthetics and personal empowerment, making it a meaningful addition to their body art collection. Our services are designed to provide a safe, respectful, and professional experience, ensuring that every client feels comfortable and confident throughout the process.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and discretion are our highest priorities. Our certified and experienced professionals use sterile, single-use, high-quality equipment to perform each intimate piercing with the utmost care and precision. We strictly follow international hygiene standards and professional protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Due to the sensitive nature of intimate piercings, our specialists are trained to handle every procedure with professionalism, respect, and attention to detail.
          </p>

          <p>
            Intimate piercing is ideal for individuals seeking a personalized and unique form of body modification that enhances both confidence and self-expression. Each piercing is carefully customized based on your preferences, anatomy, and comfort level. Our specialists take the time to provide a detailed consultation, guiding you through the available options, placement considerations, and jewelry choices to ensure the best possible outcome tailored to your needs.
          </p>

          <p>
            The procedure is typically quick and performed with advanced techniques designed to minimize discomfort while ensuring precision. We provide high-quality, hypoallergenic jewelry that is safe for sensitive skin, helping to reduce irritation and support a smooth healing process. Our goal is to deliver a professional and comfortable experience while maintaining complete privacy and confidentiality for every client.
          </p>

          <p>
            Our studio offers a clean, welcoming, and discreet environment where clients can feel at ease. We understand that intimate piercings require a higher level of trust and comfort, and our friendly, trained staff are always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a respectful, professional, and stress-free experience.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your intimate piercing, and we provide detailed, easy-to-follow instructions to ensure proper healing. Our specialists guide you on hygiene practices, recommended products, and precautions to avoid irritation or infection. Following proper aftercare is essential for healing and maintaining the long-term health and appearance of your piercing.
          </p>

          <p>
            Our intimate piercing services in the UAE combine premium quality with transparent pricing, ensuring you receive exceptional value with no hidden costs. Booking your appointment is simple and convenient, allowing you to choose a time that suits your schedule while ensuring minimal waiting time and complete privacy.
          </p>

          <p>
            Choose our trusted intimate piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, strict hygiene standards, and a commitment to client comfort and confidentiality, we help you achieve a unique and personal expression of style. Book your intimate piercing appointment today and embrace confidence with expert care and professionalism.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Intimate Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default IntimatePiercing;